import { Outlet, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  AppBar,
  Toolbar,
  Typography,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
  Button,
} from '@mui/material';
import Iconify from 'src/components/iconify';
import { PATH_ADMIN } from 'src/routes/paths';
import { adminLogout } from 'src/redux/slices/adminAuth';

const NAV_WIDTH = 240;

const NAV_ITEMS = [
  { title: 'Saques', path: PATH_ADMIN.saques, icon: 'solar:wallet-money-bold-duotone' },
  { title: 'Pontos', path: PATH_ADMIN.pontos, icon: 'solar:map-point-bold-duotone' },
];

export default function AdminLayout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(adminLogout());
    navigate(PATH_ADMIN.login);
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <Drawer
        variant="permanent"
        sx={{
          width: NAV_WIDTH,
          flexShrink: 0,
          '& .MuiDrawer-paper': { width: NAV_WIDTH, boxSizing: 'border-box' },
        }}
      >
        <Toolbar>
          <Typography variant="subtitle1" noWrap>
            Hop — Admin
          </Typography>
        </Toolbar>
        <List>
          {NAV_ITEMS.map((item) => (
            <ListItemButton key={item.path} onClick={() => navigate(item.path)}>
              <ListItemIcon>
                <Iconify icon={item.icon} />
              </ListItemIcon>
              <ListItemText primary={item.title} />
            </ListItemButton>
          ))}
        </List>
      </Drawer>

      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static" color="default" elevation={0}>
          <Toolbar sx={{ justifyContent: 'flex-end' }}>
            <Button onClick={handleLogout}>Sair</Button>
          </Toolbar>
        </AppBar>

        <Box sx={{ p: 3 }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
